import { getSessionData, setLocalUser } from '@/services/session-data';
import { USER_TYPE_OTHER } from '@/settings/consts/users';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

const UpdateUserData$: BehaviorSubject<any> = new BehaviorSubject('initialize');

function update(): void {
  getSessionData().subscribe((data) => {
    if (!!data) {
      let userData;
      if (data.tipoUsuario === USER_TYPE_OTHER) {
        userData = data.usuario;
      } else {
        delete data.medico.clientes;
        userData = data.medico;
      }
  
      const payload = {
        ...userData,
        tipoAcesso: data.tipoAcesso,
        tipoLogin: data.tipoUsuario,
        idLogin: data.idLogin,
        listaEmpresas: data.unidadesEmpresariais,
        listaUnidades: data.unidadesCliente,
        validarCelular: data.validarCelular
      };

      setLocalUser(payload);
      UpdateUserData$.next(payload);
    }
  });
}

function get(): Observable<any> {
  return UpdateUserData$.pipe(filter((val) => val !== 'initialize'));
}

export { update, get };

